import * as Redux from "redux";
import storage from "redux-persist/lib/storage";
import _ from "lodash";

import { DropActions } from "src/core/drops/store/drops.actions";
import * as AT from "src/core/drops/store/drops.constants";
import { IDrop } from "src/core/drops/api/drops.api";

export interface IDropsStore {
  drop: IDrop | null;
  lastSynced?: Date;
  userDrops: IDrop[] | null;
}

const initialState: IDropsStore = {
  drop: null,
  userDrops: null
};

export const dropsReducer: Redux.Reducer<IDropsStore> = (state: IDropsStore = initialState, action: DropActions): IDropsStore => {
  switch (action.type) {
    case AT.PURGE_DROPS:
      return {
        ...state,
        drop: null
      };

    case AT.SET_DROP:
      if (_.isEqual(action.drop, state.drop)) {
        return state;
      } else {
        return {
          ...state,
          lastSynced: new Date(),
          drop: action.drop
        };
      }

    case AT.PURGE_USER_DROPS:
      return {
        ...state,
        userDrops: null
      };

    case AT.SET_USER_DROPS:
      if (_.isEqual(action.drops, state.userDrops)) {
        return state;
      } else {
        return {
          ...state,
          lastSynced: new Date(),
          userDrops: action.drops
        };
      }

    default:
      return state;
  }
};

export const dropsPersistConfig = {
  key: "drops",
  storage,
  blacklist: [ "" ]
};
